import * as React from "react";
import {
    BaseBlock, broadcastBlockLoad,
    SportDataGateway, BFFGateway
} from "sb-resp-lib";

import { BaseDict } from "./dict";

import { EventListPresenter } from "./ui";
import { EventListPresenterState } from "./state";

import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
import { EventListOptions } from "../../typings";
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";

import { Piper } from "../../piper";
import { cmsConfig } from "./config";

import * as LOCALMOCKS from "../../mocks/";

let _localMocks: typeof LOCALMOCKS;
let _libMocks: typeof MOCKSTYPE;
let EventListOptionsMock, BffGatewayMock, SportDataGatewayMock, deviceChangeDispatcherMock;

if (process.env.NODE_ENV === "development") {
    _libMocks = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks/");
    EventListOptionsMock = _localMocks.EventListOptionsMock;
    BffGatewayMock = _localMocks.BffGatewayMock;
    SportDataGatewayMock = _localMocks.SportDataGatewayMock;
}

export class EventListPresenterRoot extends BaseBlock {
    dataProvider!: EventListPresenterState;
    options!: EventListOptions;
    // constructor sets defaults
    constructor(
        domId: string,
        options: EventListOptions,
    ) {
        super(domId, options);

        let bffGateway, sportsDataGateway;

        if (process.env.NODE_ENV === "development") {
            this.options = EventListOptionsMock;
            bffGateway = new BffGatewayMock();
            sportsDataGateway = new SportDataGatewayMock();
            deviceChangeDispatcherMock = _libMocks.DeviceChangeDispatcherMock.getInstance();
            this.options.navHandler.Navigation = {
                adjustPath: (url: string) => `en/sports/${url}`,
                getLiveEventLink: (id: string) => `en/live-betting/#${id}`,
                getLiveBettingLink: () => "en/live-betting"
            }
            this.options.navHandler.OpenLeague = () => {}
            // bffGateway = new BFFGateway();
            // sportsDataGateway = new SportDataGateway();
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            this.options = options;
            bffGateway = new BFFGateway();
            sportsDataGateway = new SportDataGateway();
        }

        window["EventListPresenterDATA"] = this.dataProvider;
        this.options.dict = { ...BaseDict, ...(this.options.dict || {}) };
        this.options.cms = { ...cmsConfig, ...(this.options.cms || {}) };

        this.dataProvider = new EventListPresenterState(
            new Parser(
                new Retriever(
                    bffGateway,
                    sportsDataGateway,
                    this.options.dataProvider,
                    deviceChangeDispatcherMock
                ),
                new Piper(this.options.dataProvider.pipeline),
                this.options.betSlipUtil,
                this.options.cms.BlockId,
                this.options.cms.BetRadarStatisticClientId,
                {
                    sportIds: this.options.dataProvider.eventsRequest.request.ids,
                    allSportIds: this.options.dataProvider.allSportIds,
                    dateRange: this.options.dataProvider.eventsRequest.request.dateRange
                },
                {
                    adjustPath: this.options.navHandler.Navigation.adjustPath,
                    adjustLivePath: this.options.navHandler.Navigation.getLiveEventLink
                },
                this.options.dataProvider.specialLeagues
            ),
            this.options
        );
    }

    activate() {
        return super.activate(
            <EventListPresenter dataProvider={this.dataProvider} dict={this.options.dict} cms={this.options.cms} />
        );
    }

    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }

    beforeDeactivate() {
        this.dataProvider.deactivate();
        return this;
    }

    setParams(sportId: string) {
        this.dataProvider.provider.setParams([sportId]);
    }
}

window["EventListPresenter"] = EventListPresenterRoot;
broadcastBlockLoad("EventListPresenter");